var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.list},_vm._l((_vm.yearsList),function(year,yearId){
var _obj;
return _c('li',{key:yearId,class:[[_vm.$style.year], ( _obj = {}, _obj[_vm.$style.active] = year === _vm.activeYear, _obj )],on:{"click":function($event){return _vm.$emit('change', year)}}},[_vm._v("\n    "+_vm._s(year)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }